import React from 'react';
import boxLogo        from '../../../Assets/box_logo.svg';
import jobitLogo      from '../../../Assets/jobit_logo.svg';
import salesforceLogo from '../../../Assets/salesforce_logo.svg';
import tableauLogo    from '../../../Assets/tableau_logo.svg';
import joWebsiteLogo  from '../../../Assets/jo_website_logo.svg';
import composeModeLogo from '../../../Assets/compose_mode_logo.svg';
import atlasChatIcon from '../../../Assets/atlas_chat_icon.svg';
import imageGenerationLogo from '../../../Assets/image_generation_logo.svg';
import webSearchLogo from '../../../Assets/web_search_logo.svg';
import openAiLogo from '../../../Assets/chat_gpt_logo.svg';
import anthropicLogo from '../../../Assets/anthropic_logo.svg';

export const BoxLogo = () => (
  <img src={boxLogo} alt="Box" width={16} height={16} style={{ objectFit: 'contain' }} />
);

export const BoxJobitLogo = () => (
  <img src={jobitLogo} alt="Box JOBIT" width={16} height={16} style={{ objectFit: 'contain' }} />
);

export const SalesforceLogo = () => (
  <img src={salesforceLogo} alt="Salesforce" width={22} height={14} style={{ objectFit: 'contain' }} />
);

export const TableauLogo = () => (
  <img src={tableauLogo} alt="Tableau" width={16} height={16} style={{ objectFit: 'contain' }} />
);

export const JoWebsiteLogo = () => (
  <img src={joWebsiteLogo} alt="JO Website" width={16} height={16} style={{ objectFit: 'contain' }} />
);

export const ComposeModeLogo = () => (
  <img src={composeModeLogo} alt="Compose" width={16} height={16} style={{ objectFit: 'contain' }} />
);

export const AtlasChatLogo = () => (
  <img src={atlasChatIcon} alt="Atlas Lead Intelligence" width={16} height={16} style={{ objectFit: 'contain' }} />
);

export const ImageGenerationLogo = () => (
  <img src={imageGenerationLogo} alt="Create Image" width={16} height={16} style={{ objectFit: 'contain' }} />
);

export const WebSearchLogo = () => (
  <img src={webSearchLogo} alt="Web Search" width={16} height={16} style={{ objectFit: 'contain' }} />
);

export const OpenAiLogo = () => (
  <img src={openAiLogo} alt="OpenAI" width={16} height={16} style={{ objectFit: 'contain' }} />
);

export const AnthropicLogo = () => (
  <img src={anthropicLogo} alt="Anthropic" width={16} height={16} style={{ objectFit: 'contain' }} />
);
